<template>
  <section class="common-error_500">
    <div class="other-box">
      <img class="other-box-img" src="@/assets/images/other.png" alt="">
      <div class="other-box-text">{{ $t('common.noPage') }}</div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'common-error_500',
}
</script>

<style lang="scss">
.common-error_500 {
  background: #fff;
  height: 100%;
  width: 100%;
  position: relative;
  user-select: none;
  .other-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    .other-box-img {
      width: 240px;
      height: 140px;
    }
    .other-box-text {
      font-size: 12px;
      color: #C4C4C4;
      margin-top: 20px;
      text-align: center;
    }
  }
}
</style>


